module.exports = __webpack_public_path__ + "img/cart-large-p.b80cd604.svg";